import { render, staticRenderFns } from "./ProductFeedbackCard.vue?vue&type=template&id=206e8050&scoped=true"
import script from "./ProductFeedbackCard.vue?vue&type=script&lang=js"
export * from "./ProductFeedbackCard.vue?vue&type=script&lang=js"
import style0 from "./ProductFeedbackCard.vue?vue&type=style&index=0&id=206e8050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206e8050",
  null
  
)

export default component.exports